import { Task, TaskExtended } from "../../shared/types/Task"


export const isDependentTaskHidden = (extendedTask: TaskExtended): boolean => {
    return !extendedTask.parentTasks.some((parentTaskObj: Task) => {
        return (parentTaskObj.enabled && parentTaskObj?.taskDependency?.hideDependentTask) ?? false
    })
}
